import { render, staticRenderFns } from "./StaffOnetimePayment.vue?vue&type=template&id=52cf6be6"
import script from "./StaffOnetimePayment.vue?vue&type=script&lang=js"
export * from "./StaffOnetimePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports